// extracted by mini-css-extract-plugin
export default {"sign_button":"styles_sign_button__Hyv3v","sign_button_text":"styles_sign_button_text__IYCyd","sign_document_iframe":"styles_sign_document_iframe__rsdej"};